export default __webpack_public_path__ + "static/media/note27-512.a295584d.png";